<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-full"
      >
        Name
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Linked to Ad Plan
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Impressions
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Clicks
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Interactions
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Engagements
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        Cost
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
